<template>
  <Card class="card company py-16">
    <v-row class="mb-6">
      <v-col class="col-12 pa-0">
        <div class="head d-flex align-stretch justify-space-between"><div class="card-title pl-7 pr-7 py-1">合作供应商</div></div>
        <v-carousel cycle hide-delimiters :show-arrows="false" height="160">
          <v-carousel-item v-for="(suppliers, i) in suppliersInFilter"
            :key="i">
            <div class="img-wrapper d-flex align-stretch">
              <div class="d-flex align-center justify-center flex-grow-1" :key="j" v-for="(item, j) in latestSupplier">
                <CloudImage class="img" :alt="item.title" :cloud-path="item.imgSrc" cover transition="fade" gradient="to bottom, rgba(0,0,0, 0), rgba(0,0,0,.7)"></CloudImage>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 pa-0">
        <div class="head d-flex align-stretch justify-space-between"><div class="card-title pl-7 pr-7 py-1">金融服务商</div></div>
        <v-carousel cycle hide-delimiters :show-arrows="false" height="160">
          <v-carousel-item v-for="(companies, i) in companiesInFilter"
            :key="i">
            <div class="img-wrapper d-flex align-stretch">
              <div class="d-flex align-center justify-center flex-grow-1" :key="j" v-for="(item, j) in latestCompanie">
                <CloudImage class="img" :alt="item.title" :cloud-path="item.imgSrc" cover transition="fade" gradient="to bottom, rgba(0,0,0, 0), rgba(0,0,0,.7)"></CloudImage>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </Card>
</template>

<script>
import { Companie, Supplier } from '@/mixins/companie'
import CloudImage from '@/components/Companie/CloudImage'
import Card from '@/components/UI/Card'
export default {
  name: 'Company',
  mixins: [Companie, Supplier],
  components: {
    Card,
    CloudImage
  },
  computed: {
    suppliersInFilter () {
      const arr = []
      const slice = 5
      for (let i = 0; i < this.latestSupplier.length; i += slice) {
        arr.push(this.latestSupplier.slice(i, i + slice))
      }
      return arr
    },
    companiesInFilter () {
      const arr = []
      const slice = 5
      for (let i = 0; i < this.latestCompanie.length; i += slice) {
        arr.push(this.latestCompanie.slice(i, i + slice))
      }
      return arr
    }
  },
  mounted () {
    this.getCompanie()
    this.getSupplier()
  }
}
</script>

<style lang="scss" scoped>
.v-window-item:nth-child(1) .img-wrapper > div{
  &:nth-child(5) ~ div {
      display: none!important;
  }
}
.v-window-item:nth-child(2) .img-wrapper > div {
  display: none!important;
  &:nth-child(5) ~ div {
    display: block!important;
  }
}
.v-window-item:nth-child(3) .img-wrapper > div {
  display: none!important;
  &:nth-child(10) ~ div {
    display: block!important;
  }
}
.company {
  .img-wrapper {
    height: 100%;
  }
}
.v-carousel {
  background-color: #fff;
}
.company .card-title {
  background-color: #3171b7;
  font-size: 18px;
  font-weight: bold;
  color: #FFF;
}
</style>
